/* eslint-disable */
const i18n = {
  "zh-CN": {
    "error": {
      "billing": {
        "missing_field": "很抱歉，你的交易被拒绝，请检查所填写的必填字段：国家/地区、城市和地址。",
        "stripe": {
          "generic_error": "错误！系统目前无法处理你的请求，请稍后重试或使用其他支付方式。如果问题仍存在，请联系相关银行或尝试其他支付方式。如果问题仍未解决，请<a href=\"https://support.zoom.us/hc/en-us/requests/new?ticket_form_id=360000983032\">提交请求</a>向Zoom寻求帮助。",
          "authentication_required": "信用卡号无效，无法处理你的购买请求。请更新信用卡信息或尝试其他支付方式。如果问题仍存在，请联系相关银行。",
          "approve_with_id": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "call_issuer": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "card_not_supported": "这张卡不允许此类交易。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "card_not_supported_invoice": "该信用卡不支持此交易类型，请联系相关银行或导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "card_velocity_exceeded": "由于资金问题，例如银行账户资金不足或超过信用卡限额，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "card_velocity_exceeded_invoice": "由于账户资金不足，付款被拒绝。请联系相关银行或导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "currency_not_supported": "由于此卡不支持此笔付款的币种，因此付款被拒绝。 请将货币换成美元再试一次，或者换一张卡。 如果问题仍然存在，请联系开户行。",
          "do_not_honor": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "do_not_try_again": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "expired_card": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "expired_card_invoice": "信用卡号无效，无法处理您的购买请求。请导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。如果问题仍存在，请联系相关银行。",
          "fraudulent": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "generic_decline": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "incorrect_number": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "incorrect_cvc": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "incorrect_pin": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "incorrect_zip": "地址无效，无法处理您的订单。 请确保您为卡输入的地址与您的银行存档的地址匹配，然后重试。 如果问题仍然存在，请联系开户行。",
          "incorrect_zip_invoice": "地址无效，无法处理您的购买请求。请导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "insufficient_funds": "由于资金问题，例如银行账户资金不足或超过信用卡限额，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "insufficient_funds_invoice": "由于账户资金不足，付款被拒绝。请联系相关银行或导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "invalid_account": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "invalid_request": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "invalid_amount": "由于金额或货币问题，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "invalid_cvc": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "invalid_expiry_year": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "invalid_expiry_month": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "invalid_number": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "invalid_pin": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "issuer_not_available": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "lost_card": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "lost_card_invoice": "信用卡存在问题，我们无法处理此请求。请联系相关银行或导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "merchant_blacklist": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "new_account_information_available": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "no_action_taken": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "not_permitted": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "offline_pin_required": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "online_or_offline_pin_required": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "pickup_card": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "pickup_card_invoice": "信用卡存在问题，我们无法处理此请求。请联系相关银行或导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "pin_try_exceeded": "你多次使用无效号码处理此卡的付款请求，现已超过允许的尝试次数。请尝试其他支付方式。",
          "processing_error": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "reenter_transaction": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "restricted_card": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "revocation_of_all_authorizations": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "revocation_of_authorization": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "security_violation": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "service_not_allowed": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "stolen_card": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "stolen_card_invoice": "信用卡存在问题，我们无法处理此请求。请联系相关银行或导航至<a href=\"/billing/payment\">账单信息</a>并更新您的支付信息。",
          "stop_payment_order": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "testmode_decline": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "transaction_not_allowed": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "transaction_not_allowed_inr": "你的卡不支持经常性交易，很可能是因为它是借记卡。请使用信用卡完成购买。",
          "try_again_later": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "card_decline_rate_limit_exceeded": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "withdrawal_count_limit_exceeded": "由于资金问题，例如银行账户资金不足或超过信用卡限额，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。"
        },
        "adyen": {
          "error_1": "付款方式存在问题，我们无法处理此请求。请联系相关银行或尝试其他付款方式。",
          "error_2": "由于信用卡号无效，无法处理你的购买。请更新信用卡信息或尝试其他付款方式。如果问题仍存在，建议联系相关银行。",
          "error_3": "由于账户资金不足，付款被拒绝。请联系相关银行或尝试其他付款方式。",
          "error_4": "你多次使用无效号码处理此卡的付款请求，现已超过允许的尝试次数。请尝试其他付款方式。",
          "error_5": "系统目前无法处理你的请求，请稍后再试或使用其他付款方式。如果问题仍存在，请联系相关银行或尝试其他付款方式。",
          "error_6": "你多次处理此付款方式的付款请求，现已超过允许的尝试次数。请尝试其他付款方式。",
          "error_7": "由于地址无效，无法处理你的购买。请更新支付信息或选择其他付款方式。",
          "currency_not_supported": "由于此卡不支持此笔付款的币种，因此付款被拒绝。 请将货币换成美元再试一次，或者换一张卡。 如果问题仍然存在，请联系开户行。",
          "invalid_cvc": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "invalid_request": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "merchant_blacklist": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "do_not_try_again": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "incorrect_zip": "地址无效，无法处理您的订单。 请确保您为卡输入的地址与您的银行存档的地址匹配，然后重试。 如果问题仍然存在，请联系开户行。",
          "issuer_not_available": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "withdrawal_count_limit_exceeded": "由于资金问题，例如银行账户资金不足或超过信用卡限额，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "insufficient_funds": "由于资金问题，例如银行账户资金不足或超过信用卡限额，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "generic_decline": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "offline_pin_required": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "not_permitted": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "expired_card": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "online_or_offline_pin_required": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "pickup_card": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "incorrect_pin": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "call_issuer": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "card_velocity_exceeded": "由于资金问题，例如银行账户资金不足或超过信用卡限额，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "card_not_supported": "这张卡不允许此类交易。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "lost_card": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "incorrect_number": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "invalid_amount": "由于金额或货币问题，付款被拒绝。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "incorrect_cvc": "银行卡详细信息无效，无法处理您的订单。 这可能包括不正确的卡号、到期日期或安全码。 请确保输入的卡详细信息与卡上显示的完全一致，然后重试。 如果问题仍然存在，请联系开户行。",
          "do_not_honor": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "approve_with_id": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "new_account_information_available": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "no_action_taken": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。",
          "invalid_account": "银行卡存在未知问题，无法处理此笔付款。 请尝试使用其他银行卡或其他付款方式。 如果问题仍然存在，请联系开户行。"
        }
      }
    },
    "billing": {
      "required": "必填",
      "enter_full_address": "请输入您的完整地址。",
      "invalid": "无效",
      "transaction_declined": "交易已拒绝",
      "accept_terms_of_service": "请同意服务条款。",
      "invalid_quantity": "无效数量",
      "not_european_country": "付款地址必须为欧盟境内地址。请使用其他结算方式以确认是否为欧盟境内居住地。",
      "expirationDate": "期满日期",
      "cvv": "信用卡验证码",
      "credit_card_number": "信用卡号",
      "card_hold_name": "卡持有人姓名",
      "enter_special_characters": "您输入的字符无效。 请删除|、~或^之类的符号以继续。",
      "invalid_zip": "\u8BF7\u8F93\u51655\u4F4D\u7F8E\u56FD\u90AE\u7F16",
      "invalid_jp_zip": "邮政编码必须只包含数值",
      "invalid_in_zip": "请输入 6 位数字的印度邮政编码",
      "first_name": "\u540D",
      "last_name": "\u59D3",
      "company_organization": "\u516C\u53F8/\u7EC4\u7EC7\u540D\u79F0",
      "email_address": "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
      "place_order": "下订单",
      "cancel": "\u53D6\u6D88",
      "pay_method": {
        "save_pay_method": "保存付款方式",
        "verify_pay_method": "验证付款方式"
      },
      "payment": {
        "paypal": "PayPal",
        "credit": "信用卡或借记卡",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "credit_name": "\u4FE1\u7528\u5361",
        "change_payment": "更改付款方式",
        "apple_pay_desc": "单击下面的按钮，可从 Apple Pay 钱包中选择付款方式。 您可以在完成购买前查看订单。",
        "apple_pay_not_supported": "Apple Pay 付款选项仅在符合条件且运行 Safari 浏览器的 Apple 设备上受支持。",
        "google_pay_desc": "单击下面的按钮，可从 Google Pay 钱包中选择付款方式。",
        "google_pay_not_supported": "Google Pay 付款选项在您的设备或 Web 浏览器上不受支持。",
        "payment_title": "\u652F\u4ED8\u65B9\u5F0F",
        "paypal_pending_desc": "您将转至 PayPal 授权计费协议。 请确保未阻止弹出窗口。 此时不会向您收取费用。",
        "p24": "Przelewy24",
        "p24_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230Przelewy24\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002<br>\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "sofort": "Sofort",
        "sofort_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230SOFORT\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002<br>\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "sofort_upgrade_message": "SOFORT/SEPA\u65E0\u6CD5\u7528\u4E8E\u5347\u7EA7\u3002\u8BF7\u5355\u51FB\u201C\u7F16\u8F91\u201D\u94FE\u63A5\u66F4\u6539\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "customer_balance": "\u632f\u8fbc",
        "customer_balance_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230Furikomi\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002<br>\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "customer_balance_upgrade_message": "Furikomi无法用于升级。请单击“编辑”链接更改付款方式。",
        "ideal": "iDEAL",
        "ideal_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230iDEAL\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002<br/>\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "ideal_upgrade_message": "iDEAL/SEPA\u65E0\u6CD5\u7528\u4E8E\u5347\u7EA7\u3002\u8BF7\u5355\u51FB\u201C\u7F16\u8F91\u201D\u94FE\u63A5\u66F4\u6539\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "us_bank_account": "\u7f8e\u56fd ACH \u76f4\u63a5\u501f\u8bb0",
        "us_bank_account_desc": "\u60a8\u5c06\u8f6c\u81f3\u201c\u94f6\u884c\u8d26\u6237\u8f6c\u8d26\u201d\u6388\u6743\u8ba1\u8d39\u534f\u8bae\u3002 \u8bf7\u786e\u4fdd\u672a\u963b\u6b62\u5f39\u51fa\u7a97\u53e3\u3002\u8fd9\u5c06\u6210\u4e3a\u60a8\u5b58\u6863\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002\u8bf7\u6ce8\u610f\uff1a\u6240\u9700\u7684\u8d26\u6237\u53d8\u66f4\u4fe1\u606f\u53ef\u80fd\u4f1a\u56e0\u94f6\u884c\u8f6c\u8d26\u65f6\u6548\u800c\u5ef6\u8fdf\u3002\u5982\u6709\u6025\u9700\uff0c\u8bf7\u9009\u62e9\u94f6\u884c\u5361\u4ed8\u6b3e\u3002",
        "us_bank_account_upgrade_message": "ACH \u94f6\u884c\u8f6c\u8d26\u4e0d\u80fd\u7528\u4e8e\u5347\u7ea7\u3002 \u8bf7\u5355\u51fb\u201c\u7f16\u8f91\u201d\u94fe\u63a5\u66f4\u6539\u60a8\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002",
        "klarna": "立即购买，稍后付款",
        "klarna_desc": "您将转至Klarna以授权计费协议。请确保未阻止弹出窗口。这将成为您存档的付款方式。",
        "klarna_upgrade_message": "Klarna 银行转账不能用于升级。 请单击“编辑”链接更改您的付款方式。",
        "klarna_monthly_upgrade_message": "Klarna 仅适用于年度订阅。 请转为年度订阅或尝试其他付款方式。",
        "klarna_payment_catgory": {
          "pay_in_installments": "分期付款",
          "pay_later": "稍后付款",
          "pay_now": "立即支付",
          "pay_with_financing": "融资"
        },
        "wise_plus_banktransfer": "Wise + 银行转账",
        "trustly": "Trustly +",
        "wise_plus_trustly": "Wise + Trustly",
        "interac": "Interac +",
        "wise_plus_interac": "Wise + Interac",
        "payid": "PayID +",
        "wise_plus_payid": "Wise + PayID",
        "fpx": "FPX +",
        "wise_plus_fpx": "Wise + FPX",
        "poli": "POLI +",
        "wise_plus_poli": "Wise + POLI",
        "paynow": "PayNow +",
        "wise_plus_paynow": "Wise + PayNow",
        "bacs": "BACS +",
        "wise_plus_bacs": "Wise+BACS",
        "fps": "FPS +",
        "wise_plus_fps": "Wise+FPS",
        "openbanking": "开放银行 +",
        "wise_plus_openbanking": "Wise+Open Banking",
        "wise_plus_boleto": "Wise + Boleto",
        "wise_plus_pix": "Wise + Pix",
        "wise": "Wise",
        "wise_upgrade_message": "Wise无法用于升级。请单击“编辑”链接更改您的付款方式。",
        "wise_desc": "您将转至 WISE 授权计费协议。 请确保未阻止弹出窗口。 这将成为您存档的付款方式。<br><br><strong>请注意：</strong>请求的账户更改可能会因银行转账时效而延迟。 如有急需，请选择银行卡付款。",
        "pay_with": "付款方式",
        "bill_same_as_contact": "请为此付款方式使用以下地址",
        "waiting_auth_pay_method_title": "授权付款方式",
        "waiting_auth_pay_method_desc": "请勿关闭此页面或点击返回按钮。 前往弹出窗口完成授权。",
        "waiting_updating_pay_method_title": "更新支付方式",
        "waiting_updating_pay_method_desc": "请不要关闭此页面。",
        "waiting_check_title": "请稍等，正在处理您的订单...",
        "waiting_check_desc": "请等待确认，然后再返回或关闭浏览器。",
        "update_pay_method_tips": "请更新或取消对付款方式所作的更改",
        "ach": {
          "name": "ACH",
          "verify_failed": "您的付款方式验证失败。 请前往<a href=\"/billing/payment\">账单信息</a>更新您的付款方式。",
          "verify_pending_error": "由于您的付款方式正在等待验证，您无法完成此次付款。 请转至<a href=\"/billing/payment\">账单信息</a>并完成验证，然后重试。"
        },
        "sepa": "SEPA",
        "others": "其他",
        "pay_with_international_card": "使用支持境外消费的信用卡或借记卡支付。 向银行确认是否可使用信用卡及其使用费用。",
        "apm_payment_error": "请更换付款方式。",
        "apm_flow_lost_message": "看起来流程存在问题。 请重试并使用 {0} 完成付款。"
      },
      "zip_postal": "\u90AE\u7F16",
      "city": "\u57CE\u5E02",
      "state": "\u5DDE/\u7701",
      "select_state": "\u9009\u62E9\u5DDE/\u7701",
      "country_region": "\u56FD\u5BB6/\u5730\u533A",
      "company_organization_legal": "\u516C\u53F8\u6CD5\u5B9A\u540D\u79F0",
      "just_me": "\u53EA\u6709\u6211",
      "pop_up_blocked": "\u5F39\u51FA\u7A97\u53E3\u88AB\u5C4F\u853D\uFF0C\u8BF7\u5141\u8BB8\u5F39\u51FA\u7A97\u53E3\u5E76\u91CD\u8BD5\u3002",
      "unknown_error": "\u672A\u77E5\u9519\u8BEF\uFF01",
      "not_vat_registered": "\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0",
      "vat_checkbox_desc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E\u6B27\u76DF\u6CD5\u5F8B\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
      "not_vat_tips": "\u5982\u679C\u4F60\u662F\u4E00\u5BB6\u5DF2\u6CE8\u518C\u7684\u6B27\u76DF\u4F01\u4E1A\uFF0C\u5219\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801",
      "vat_SN_message": "如果您已登记增值税，请输入税号，它将显示在向您开具的发票上。",
      "vat_SN_placeholder": "税号",
      "vat_number": "\u589E\u503C\u7A0E\u53F7\u7801",
      "amMsg": "\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u767B\u8BB0\u53F7\u7801",
      "amMsgDesc": "\u901A\u8FC7\u9009\u4E2D\u6B64\u6846\uFF0C\u672C\u4EBA\u786E\u8BA4\u672C\u4EBA/\u6211\u4EEC\u5DF2\u5728\u4E9A\u7F8E\u5C3C\u4E9A\u6CE8\u518C\u589E\u503C\u7A0E\u3002 \u6211\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u58F0\u660E\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u5DF2\u5728\u4E9A\u7F8E\u5C3C\u4E9A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA\u63A5\u53D7\u5E76\u7406\u89E3Zoom\u4E0D\u4F1A\u6536\u53D6\u4E9A\u7F8E\u5C3C\u4E9A\u589E\u503C\u7A0E\uFF0C\u5E76\u4E14\u672C\u4EBA/\u6211\u4EEC\u53EF\u80FD\u9700\u8981\u81EA\u884C\u8BC4\u4F30\u5E94\u4ED8\u7684\u589E\u503C\u7A0E\u3002",
      "mdMsgDesc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u4E0D\u662F\u5546\u4E1A\u5BA2\u6237\uFF08\u5373\u9002\u7528\u4E8E\u6469\u5C14\u591A\u74E6\u7A0E\u6536\u76EE\u7684\u7684\u6CD5\u5F8B\u5B9E\u4F53\uFF09\u3002 \u672C\u4EBA\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u7A0E\u52A1\u72B6\u6001\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u4E0D\u662F\u5546\u4E1A\u5BA2\u6237\uFF08\u5373\u9002\u7528\u4E8E\u6469\u5C14\u591A\u74E6\u7A0E\u6536\u76EE\u7684\u7684\u6CD5\u5F8B\u5B9E\u4F53\uFF09\uFF0C\u5373\u8868\u793A\u672C\u4EBA\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\uFF08\u5982\u9002\u7528\uFF09\u3002",
      "vat_registration_placeholder": "\u589E\u503C\u7A0E\u767B\u8BB0\u53F7\u7801",
      "registered_for_vat": "\u5DF2\u6CE8\u518C\u589E\u503C\u7A0E",
      "not_gst_tips_for_au": "如果您的企业已注册澳大利亚商品和服务税 (GST)，请输入澳大利亚商业编号 (ABN)。 提供 ABN 即表示，您声明您已注册澳大利亚商品和服务税，并为您在澳大利亚经营的企业购买 Zoom 服务（而非供私人或家庭使用）。",
      "gst_number": "GST\u53F7\u7801",
      "not_gst_registered": "\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0",
      "gst_checkbox_desc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3Zoom\u5C06\u6839\u636E\u5F53\u5730\u6CD5\u5F8B\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6309\u9002\u7528\u7A0E\u7387\u5F81\u6536\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u3002",
      "vat_header_val_BS": "\u5982\u679C\u4F60\u5DF2\u5728\u5DF4\u54C8\u9A6C\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u4F60\u7684TIN\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u4E3A\u4F60\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
      "vat_header_val_BH": "\u5982\u679C\u60A8\u5DF2\u5728\u5DF4\u6797\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u60A8\u7684\u589E\u503C\u7A0E\u53F7\u3002",
      "vat_id_number_placeholder": "\u589E\u503C\u7A0E\u53F7",
      "vat_checkout_popup_message_IS_BH": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u6D88\u8D39\u8005\u3001\u4F01\u4E1A\u6216\u653F\u5E9C\u673A\u6784\u5E76\u672A\u529E\u7406\u7A0E\u8D39\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u7A0E\u52A1\u72B6\u6001\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u6D88\u8D39\u8005\u3001\u4F01\u4E1A\u6216\u653F\u5E9C\u673A\u6784\u5E76\u672A\u6CE8\u518C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\uFF08\u5982\u679C\u9002\u7528\uFF09\u3002",
      "vat_header_val_BD": "\u5982\u679C\u60A8\u5DF2\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165BIN",
      "vat_checkout_popup_message_BD": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u5E76\u672A\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u6458\u8981\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
      "vat_header_val_BB": "\u5982\u679C\u4F60\u5DF2\u5728\u5DF4\u5DF4\u591A\u65AF\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u4F60\u7684\u589E\u503C\u7A0E\u53F7\u7801\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u4E3A\u4F60\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
      "tin_number": "TIN \u7F16\u53F7",
      "vat_header_val_KHM": "\u5982\u679C\u60A8\u5DF2\u5728\u67EC\u57D4\u5BE8\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u3002",
      "vat_checkout_popup_message_KHM": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
      "vat_header_val_CM": "如果您是商业版客户，请输入您的 NIU，它将显示在向您开具的发票上",
      "tax_promote_cl": "\u8BF7\u8F93\u5165\u7A0E\u53F7(RUT)\u5E76\u5FFD\u7565\u5C0F\u6570\u548C\u8FDE\u5B57\u7B26\u3002",
      "rut_number": "RUT\u53F7\u7801",
      "vat_header_val_GE": "\u5982\u679C\u4F60\u5728\u683C\u9C81\u5409\u4E9A\u6CE8\u518C\u4E86\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
      "vat_checkout_popup_message": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6{0}\u7684\u589E\u503C\u7A0E\u3002",
      "vat_checkout_popup_message_GE": "\u683C\u9C81\u5409\u4E9A",
      "vat_header_val_GH": "\u5982\u679C\u60A8\u5DF2\u5728\u52A0\u7EB3\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u3002",
      "vat_header_val_IS": "\u5982\u679C\u60A8\u5DF2\u5728\u51B0\u5C9B\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u60A8\u7684\u589E\u503C\u7A0E\u53F7\u3002",
      "inMsg": "\u5BF9\u4E8E\u5DF2\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u7684\u4F01\u4E1A\uFF0C\u8BF7\u8F93\u5165\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u53F7\u7801\u3002\u5982\u679C\u65E0\u6CD5\u63D0\u4F9B\u6709\u6548\u7684GSTIN\uFF0C\u5C06\u5BFC\u81F4\u65E0\u6CD5\u5F00\u7ACB\u7535\u5B50\u53D1\u7968\u3002\u5C06\u81EA\u52A8\u9A8C\u8BC1SEZ\u72B6\u6001\u3002<br /><br />ZVC India\u5FC5\u987B\u5411\u5370\u5EA6\u5883\u5185\u6CE8\u518C\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7684\u5BA2\u6237\u5F00\u5177\u7535\u5B50\u53D1\u7968\u3002\u4E3A\u6B64\uFF0C\u52A1\u5FC5\u786E\u4FDD\u4F60\u7684\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u767B\u8BB0\u53F7\u7801\u6240\u5206\u914D\u5230\u7684\u5DDE\u4E0E\u4F60\u7684\u8D26\u5355\u90AE\u5BC4\u5730\u5740\u53CA\u8BA2\u8D27\u65B9\u5730\u5740\u6240\u5C5E\u7684\u5DDE\u4FDD\u6301\u4E00\u81F4\u3002",
      "gst_checkbox_desc_template": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E{0}\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u3002",
      "tax_checkbox_desc_non_inr_in": "\u5370\u5EA6\u6CD5\u5F8B",
      "tax_promote_vat_cat1": "\u5982\u679C\u4F60\u662F\u589E\u503C\u7A0E\u6CE8\u518C\u5BA2\u6237\uFF0C\u8BF7\u586B\u5199\u5C06\u4E8EZoom\u53D1\u9001\u7ED9\u4F60\u7684\u53D1\u7968\u4E0A\u663E\u793A\u7684\u589E\u503C\u7A0E\u53F7\u7801",
      "tax_number_on_invoice_tips": "\u5982\u679C\u4F60\u5E0C\u671B\u5728Zoom\u7ED9\u4F60\u5F00\u7684\u53D1\u7968\u4E0A\u663E\u793A\u4F60\u7684\u7A0E\u53F7\uFF0C\u8BF7\u5728\u6B64\u5904\u8F93\u5165\u8BE6\u60C5\u3002",
      "vat_header_val_KAZ": "\u5982\u679C\u4F60\u5DF2\u5728\u54C8\u8428\u514B\u65AF\u5766\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
      "vat_checkout_popup_message_KAZ": "\u54C8\u8428\u514B\u65AF\u5766",
      "keMsg": "\u8BF7\u8F93\u5165\u60A8\u7684\u4E2A\u4EBA\u6807\u8BC6\u53F7(PIN)\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u53D1\u7ED9\u60A8\u7684\u53D1\u7968\u4E0A\u3002",
      "pin_number": "PIN\u53F7\u7801",
      "tax_promote_my": "\u5982\u679C\u4F60\u662F\u7A0E\u52A1\u6CE8\u518C\u5BA2\u6237\uFF0C\u8BF7\u586B\u5199\u5C06\u4E8EZoom\u53D1\u9001\u7ED9\u4F60\u7684\u53D1\u7968\u4E0A\u663E\u793A\u7684\u7A0E\u53F7",
      "tax_checkbox_md": "\u975E\u4F01\u4E1A\u5BA2\u6237",
      "ngMsg": "\u5982\u679C\u60A8\u662F\u4F01\u4E1A\u5BA2\u6237\uFF0C\u8BF7\u63D0\u4F9B\u60A8\u7684\u7A0E\u52A1\u6807\u8BC6\u53F7(TIN)\uFF0C\u8FD9\u5C06\u663E\u793A\u5728Zoom\u4E3A\u60A8\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
      "tax_promote_no": "\u8BF7\u4E8E\u201CMVA\u201D\u524D\u8F93\u51659\u4F4D\u589E\u503C\u7A0E\u53F7",
      "mva_number": "MVA\u53F7\u7801",
      "tax_checkbox_desc_template": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E{0}\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
      "tax_checkbox_desc_no": "\u632A\u5A01\u6CD5\u5F8B",
      "vat_header_val_OM": "\u5982\u679C\u4F60\u5728\u963F\u66FC\u6CE8\u518C\u4E86\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
      "vat_checkout_popup_message_OM": "\u963F\u66FC",
      "vat_checkout_popup_message_RU": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u4FC4\u7F57\u65AF\u589E\u503C\u7A0E\u3002",
      "tax_promote_default": "\u5982\u679C\u4F60\u662F\u5DF2\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u7684\u4F01\u4E1A\uFF0C\u5219\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801",
      "vat_header_val_RS": "\u5982\u679C\u4F60\u5DF2\u5728\u585E\u5C14\u7EF4\u4E9A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u4F60\u7684\u589E\u503C\u7A0E\u53F7\u7801\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u4E3A\u4F60\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
      "not_gst_tips": "\u5BF9\u4E8E\u5DF2\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u7684\u4F01\u4E1A\uFF0C\u8BF7\u8F93\u5165GST\u53F7\u7801",
      "vat_header_val_TW": "\u5982\u679C\u60A8\u5DF2\u5728\u53F0\u6E7E\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
      "vat_checkout_popup_message_TW": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u53F0\u6E7E\u589E\u503C\u7A0E\u3002",
      "vat_header_val_TZ": "\u5982\u679C\u60A8\u5DF2\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u767B\u8BB0\u53F7\u7801(VRN)",
      "tax_promote_tr": "\u5982\u679C\u4F60\u5DF2\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801",
      "tax_input_placeholder": "\u7A0E\u52A1\u6807\u8BC6\u53F7",
      "tax_checkbox_desc_tr": "\u571F\u8033\u5176\u6CD5\u5F8B",
      "ugMsg": "\u5982\u679C\u60A8\u5DF2\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165TIN",
      "vat_header_val_UKR": "\u5982\u679C\u4F60\u5DF2\u5728\u4E4C\u514B\u5170\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
      "vat_checkout_popup_message_UKR": "\u4E4C\u514B\u5170",
      "tax_checkbox_by": "\u514D\u7A0E",
      "uzCheckboxMsg": "勾选此框即表明，我确认我代表商业版客户（即乌兹别克斯坦税务方面的法人实体）行事，且我并非乌兹别克斯坦税务目的下的个人或个体企业家。 我对本声明的准确性和完整性负全部责任。 对于不完整或不准确的声明，Zoom 不承担任何责任。 此外，在证明我代表的是商业版客户而不是乌兹别克斯坦税务目的下的个人或个体企业家时，我接受并理解 Zoom 不会向乌兹别克斯坦收取增值税，我所代表的商业版客户可能需要自行评估应付的增值税。",
      "vat_header_val_VNM": "\u5982\u679C\u60A8\u662F\u5546\u4E1A\u7248\u5BA2\u6237\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u3002\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u5373\u8868\u793A\u5BA2\u6237\u58F0\u660E\u5176\u4E3A\u4F01\u4E1A\u5BA2\u6237\uFF0C\u56E0\u6B64\u6709\u8D23\u4EFB\u5411\u8D8A\u5357\u7A0E\u52A1\u673A\u6784\u7533\u62A5\u4EFB\u4F55\u5E94\u4ED8\u7A0E\u6B3E\u3002",
      "vat_checkout_popup_message_VNM": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u7A0E\u8D39\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u7A0E\u52A1\u72B6\u6001\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u5E76\u672A\u767B\u8BB0\u7EB3\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u6458\u8981\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\uFF08\u5982\u679C\u9002\u7528\uFF09\u3002",
      "tax_promote": {
        "include_your_vat_number": "\u5982\u679C\u60A8\u662F\u5DF2\u6CE8\u518C\u589E\u503C\u7A0E\u7684\u5BA2\u6237\uFF0C\u8BF7\u586B\u5199\u589E\u503C\u7A0E\u53F7\u7801"
      },
      "tax_number_promote": {
        "default": "\u5982\u679C\u60A8\u662F\u5546\u4E1A\u7248\u5BA2\u6237\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7"
      },
      "vat": {
        "GB_message": "如果您是企业客户，请输入增值税号",
        "local_tootip": "In completing the checkbox I/we certify that the above named business is not VAT registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not VAT registered I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in accordance to local legislation in addition to the prices listed in Order Summary.",
        "UK_tootip": "In completing the checkbox I/we certify that the above named business is not VAT registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not VAT registered I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in accordance to UK legislation in addition to the prices listed in Order Summary.",
        "msg_by": "如果您是商业客户，请输入您的纳税识别号 (TIN)",
        "checkbox_by": "非商业客户",
        "tooltip_by": "在填写复选框时，我/我们证实，我/我们不是白俄罗斯税务方面的法人实体，且我/我们对于本声明的准确性和完整性承担全部责任。 对于不完整或不准确的声明，Zoom 不承担任何责任。 此外，在证明我/我们不是白俄罗斯应纳税的商业客户时，我/我们接受并理解 Zoom 将对所有应税服务收取订单摘要中所列价格之外的适用税率的增值税。",
        "msg_co": "如果您已注册增值税，请输入您的税号 (RUT)",
        "placeholder_co": "RUT",
        "tooltip_co": "在填写复选框时，我/我们证实，上述企业既不是 IVA 责任企业，也不是增值税征税人，我/我们对本声明的准确性和完整性负全部责任。 对于因 VAT 注册信息披露不完整或不准确而造成的责任，Zoom 不承担任何责任。 此外，在证明上述企业不是 IVA 责任企业或增值税征税人时，我/我们接受并理解 Zoom 将按订单摘要中所列价格之外的适用税率对所有应税服务收取增值税。",
        "tooltip_cl": "在填写复选框时，我/我们证实，以上列名企业并未进行 VAT 注册，且我/我们对于本声明的准确性和完整性承担全部责任。 对于因 VAT 注册信息披露不完整或不准确而造成的责任，Zoom 不承担任何责任。 此外，在证明上述企业未注册增值税时，我/我们接受并理解 Zoom 将对所有应税服务收取订单摘要中所列价格之外的适用税率的增值税。",
        "tooltip_eg": "在填写复选框时，我/我们证实，以上列名企业/个人并未进行 VAT 注册，且我/我们对于本声明的准确性和完整性承担全部责任。 对于因 VAT 注册信息披露不完整或不准确而造成的责任，Zoom 不承担任何责任。 此外，在证明上述企业/个人未注册增值税时，我/我们接受并理解 Zoom 将对所有应税服务收取订单摘要中所列价格之外的适用税率的增值税。",
        "msg_kr": "输入经营注册号",
        "msg_th": "如果您已注册增值税，请输入您的增值税号",
        "tax_promote_eg": "如果您已注册增值税，请输入税务登记号",
        "tax_registration_number": "税务登记号",
        "vat_cat2_checkbox_desc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E\u5F53\u5730\u6CD5\u5F8B\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
        "tax_requirement": {
          "desc": "我确认，为了遵守沙特税法，沙特客户必须预扣税款，将相关金额汇给主管当局，维护记录以证明预扣税的正确性，并向 Zoom 提供相应的预扣税款证明。 我了解，根据沙特法律，不遵守这些要求可能会受到处罚。<br /><br />预扣税证明可发送至：<a href=\"mailto:{email}\">{email}</a>",
          "invalid_msg": "必须填写复选框"
        }
      },
      "export_control": {
        "biz_org_type": "\u4F01\u4E1A/\u7EC4\u7EC7\u7C7B\u578B",
        "input_placeholder": "\u8F93\u5165\u4F01\u4E1A/\u7EC4\u7EC7\u7C7B\u578B",
        "biz": "零售/批发",
        "fin": "\u94F6\u884C\u6216\u5176\u4ED6\u91D1\u878D\u673A\u6784",
        "edu": "幼儿园及中小学教育",
        "med": "\u516C\u5171\u536B\u751F\u6216\u533B\u7597\u7EC4\u7EC7",
        "util": "\u516C\u7528\u4E8B\u4E1A",
        "telcomm": "\u56FD\u5BB6\u7535\u4FE1\u516C\u53F8",
        "edu_high": "\u5927\u5B66/\u9AD8\u7B49\u6559\u80B2",
        "sci_tech_inst": "\u79D1\u6280\u7814\u7A76\u673A\u6784\u6216\u56FD\u5BB6\u5B9E\u9A8C\u5BA4",
        "gov": "\u56FD\u5BB6\u3001\u7701/\u5DDE\u6216\u5F53\u5730\u653F\u5E9C\u673A\u6784\u3001\u529E\u516C\u5BA4\u6216\u653F\u5E9C\u90E8\u95E8",
        "other": "\u5176\u4ED6",
        "adv": "广告",
        "mfg": "制造业和工业",
        "ps": "专业服务和咨询",
        "bp": "生物技术/制药",
        "cnstr": "建筑",
        "ent": "娱乐",
        "lgl": "法律",
        "hpy": "酒店服务",
        "np": "非营利",
        "tech": "技术",
        "trans": "运输",
        "re": "房地产"
      },
      "tax_exemption": {
        "ttr": {
          "link": "验证免税资格",
          "link_desc": "请确保弹出窗口未被阻止，以便您跳转至 ECMS 并验证您的免税资格。",
          "in_progress_title": "正在进行免税验证",
          "in_progress_desc": "请在我们的合作伙伴网站上完成免税验证。 税务状况验证完成后，您将返回此处完成订单。<br/><br/>在验证完成之前，请勿关闭或对此页面进行任何修改。 如果您不再需要进行免税申请，您可以关闭并继续下订单。",
          "in_progress_close_button": "关闭",
          "quit_progress_title": "确定？",
          "quit_progress_desc": "您确定要放弃免税验证，并以符合纳税条件的身份继续执行吗？",
          "quit_progress_confirm": "是，放弃",
          "quit_progress_cancel": "不，继续",
          "status_incomplete": "验证未完成，如果您希望免税，请重新单击",
          "status_exempt": "免税",
          "status_pending": "待定",
          "status_retrieving": "正在检索...",
          "status_nonexempt": "不免税",
          "tax_status_label": "税务状况：{0}",
          "status_pending_desc": "目前正在审查您的免税资格。 下订单时，我们将向您收取税费，如果审核通过，我们将抵免向该账户收取的税费。",
          "status_retrieving_desc": "我们正在检索您的免税资格，请稍候。"
        }
      },
      "video_sdk": {
        "use_case": "开发用例",
        "use_case_other": "其他，请指定"
      },
      "usecase": {
        "gaming": "Gaming",
        "retail": "Retail",
        "social": "Social",
        "wellness": "Wellness",
        "e_learning": "在线学习",
        "telehealth": "远程医疗",
        "fintech": "金融科技",
        "legal": "法律",
        "hr_staffing": "人力资源/人事",
        "fitness": "健身",
        "events": "活动",
        "other": "其他"
      },
      "address": {
        "text": "\u5730\u5740",
        "street_address": "街道地址",
        "address_line2": "地址行 2",
        "phone": "\u7535\u8BDD\u53F7\u7801"
      },
      "addr": {
        "street_info": "街道地址信息将用作“买方”地址，以确定可能适用的任何税费。",
        "line_2": "地址行 2",
        "biz_info": "这是公司地址",
        "doing_biz_as_name": "\u516C\u53F8\u7ECF\u8425\u522B\u79F0",
        "doing_biz_as_name_tips": "\u5982\u679C\u4F01\u4E1A\u7ECF\u8425\u6240\u7528\u540D\u79F0\u4E0E\u6240\u6709\u8005\u540D\u79F0\u6216\u516C\u53F8\u6CD5\u5B9A\u540D\u79F0\u4E0D\u540C\uFF0C\u5219\u9002\u7528\u3002",
        "business_size": "公司规模",
        "org_name": "组织名称",
        "org_size": "组织规模",
        "hq": "公司总部所在国家/地区",
        "for_edu": {
          "tip": "此账户适用于为 18 岁以下儿童及青少年提供服务的学校或其他组织。",
          "select_apply": "该组织为哪个年龄段提供服务？ （选择所有适用选项）*",
          "under_13": "13 岁以下",
          "range_n_m": "{0} 至 {1} 岁"
        }
      },
      "error": {
        "inr_non_india_error": "要使用印度卢比完成购买行为，您的联系人地址必须位于印度。 如果您想选择其他国家/地区，请",
        "inr_non_india_error_switch_to_usd": "切换为美元",
        "empty_valid": "{0}为必填项",
        "required_field_not_completed": "未填写必填字段",
        "common": {
          "bank_account_number": "银行账号"
        },
        "ach": {
          "bank_routing_number": "银行 ABA/汇款路线号码",
          "bank_account_type": "银行账户类型",
          "bank_name": "银行名称",
          "account_holder_name": "银行账户持有人姓名"
        },
        "sepa": {
          "bank_account_name": "银行账户名称",
          "street_number": "街道编号",
          "street_name": "街道名称",
          "account_email": "电子邮件",
          "account_country": "国家/地区"
        }
      },
      "terms": {
        "india_emandate_desc": "<p><b>电子授权协议</b><br>为了向您的发卡机构注册电子授权，您需要特别授权 Zoom Video Communications 根据以下电子授权详细信息从您的卡中划走您所购买服务的订阅费：<br><br>电子授权开始日期：{0}<br>电子授权结束日期：{1}<br>金额：达到 {2}（Zoom 仅收取应付总额以内的费用）<br><br>确认已仔细阅读并理解本声明。您知晓，此电子授权的注册需要按照发卡机构的正当程序进行额外的身份验证，并且您可以随时撤回、查看或修改此电子授权。</p>",
        "emandate_charge_process_table": {
          "table_desc": "如何处理周期性费用？",
          "threshold_header": "费用金额",
          "threshold_1": "达到 {0}",
          "threshold_2": "超过 {0}",
          "action_header": "操作",
          "action_1": "我们将根据下面的电子授权协议，通过自动支付处理您每个计费周期的付款。",
          "action_2": "我们将在您每个计费周期的付款到期时通知您。您每次都需要通过 <a href=\"https://zoom.us/paynow\" target=\"_blank\">zoom.us/paynow</a> 进行手动支付。"
        },
        "pay_method_tokenization_disclaimer": "您同意，我们授权的第三方令牌服务商对您的卡数据进行标记，以使我们能够保存您的首选付款方式并将其用于支付周期性费用。",
        "sepa_payment_terms": "提供你的付款信息并确认此付款，即表示你授权(A)Zoom Video Communications, Inc.和我们的支付服务提供商Stripe，和/或其本地服务提供商PPRO，向你的银行发送从你的账户扣款的指示，并授权(B)你的银行根据这些指示从你的账户扣款。 作为你的权利的一部分，你有权依据你与银行之间协议的条款和条件，要求银行退款。 退款请求必须在账户扣款日期起8周内提出。 银行提供的声明中对你的权利有具体说明。 你同意在未来扣款2天前接收通知。"
      }
    },
    "us": {
      "state_aa": "\u7F8E\u6D32\u519B\u961F",
      "state_ae": "\u6B27\u6D32\u3001\u4E2D\u4E1C\u5730\u533A\u3001&amp;\u52A0\u62FF\u5927\u6B66\u88C5\u90E8\u961F",
      "state_ap": "\u592A\u5E73\u6D0B\u6B66\u88C5\u90E8\u961F",
      "state_al": "\u963F\u62C9\u5DF4\u9A6C",
      "state_ak": "\u963F\u62C9\u65AF\u52A0",
      "state_az": "\u4E9A\u5229\u6851\u90A3",
      "state_ar": "\u963F\u80AF\u8272",
      "state_ca": "\u52A0\u5229\u798F\u5C3C\u4E9A",
      "state_co": "\u79D1\u7F57\u62C9\u591A",
      "state_ct": "\u5EB7\u6D85\u72C4\u683C",
      "state_wd": "\u534E\u76DB\u987F\u7279\u533A",
      "state_de": "\u7279\u62C9\u534E",
      "state_fl": "\u4F5B\u7F57\u91CC\u8FBE",
      "state_ga": "\u4F50\u6CBB\u4E9A",
      "state_gu": "\u5173\u5C9B",
      "state_hi": "\u590F\u5A01\u5937",
      "state_id": "\u7231\u8FBE\u8377",
      "state_il": "\u4F0A\u5229\u8BFA\u4F0A",
      "state_in": "\u5370\u7B2C\u5B89\u7EB3",
      "state_ia": "\u7231\u8377\u534E",
      "state_ks": "\u582A\u8428\u65AF",
      "state_ky": "\u80AF\u5854\u57FA",
      "state_la": "\u8DEF\u6613\u65AF\u5B89\u90A3",
      "state_me": "\u7F05\u56E0",
      "state_md": "\u9A6C\u91CC\u5170\u5DDE",
      "state_ma": "\u9A6C\u8428\u8BF8\u585E\u5DDE",
      "state_mi": "\u5BC6\u6B47\u6839",
      "state_mn": "\u660E\u5C3C\u82CF\u8FBE",
      "state_ms": "\u5BC6\u897F\u897F\u6BD4",
      "state_mo": "\u5BC6\u82CF\u91CC",
      "state_mt": "\u8499\u5927\u62FF",
      "state_ne": "\u5185\u5E03\u62C9\u65AF\u52A0",
      "state_nv": "\u5185\u534E\u8FBE",
      "state_nh": "\u65B0\u7F55\u5E03\u4EC0\u5C14",
      "state_nj": "\u65B0\u6CFD\u897F",
      "state_nm": "\u65B0\u58A8\u897F\u54E5",
      "state_ny": "\u7EBD\u7EA6",
      "state_nc": "\u5317\u5361\u7F57\u6765\u7EB3",
      "state_nd": "\u5317\u8FBE\u79D1\u4ED6",
      "state_oh": "\u4FC4\u4EA5\u4FC4",
      "state_ok": "\u4FC4\u514B\u62C9\u8377\u9A6C",
      "state_or": "\u4FC4\u52D2\u5188",
      "state_pa": "\u5BBE\u5915\u6CD5\u5C3C\u4E9A",
      "state_pr": "\u6CE2\u591A\u9ECE\u5404",
      "state_ri": "\u7F57\u5F97\u5C9B",
      "state_sc": "\u5357\u5361\u7F57\u6765\u7EB3",
      "state_sd": "\u5357\u8FBE\u79D1\u4ED6",
      "state_tn": "\u7530\u7EB3\u897F",
      "state_tx": "\u5FB7\u514B\u8428\u65AF",
      "state_ut": "\u72B9\u4ED6",
      "state_vt": "\u4F5B\u8499\u7279",
      "state_va": "\u5F17\u5409\u5C3C\u4E9A",
      "state_vi": "\u7EF4\u4EAC\u7FA4\u5C9B",
      "state_wa": "\u534E\u76DB\u987F",
      "state_wv": "\u897F\u5F17\u5409\u5C3C\u4E9A",
      "state_wi": "\u5A01\u65AF\u5EB7\u8F9B",
      "state_wy": "\u6000\u4FC4\u660E"
    },
    "ca": {
      "state_aa": "\u963F\u5C14\u4F2F\u8FBE",
      "state_ba": "\u82F1\u5C5E\u54E5\u4F26\u6BD4\u4E9A",
      "state_ma": "\u66FC\u5C3C\u6258\u5DF4",
      "state_nd": "\u65B0\u4E0D\u4F26\u745E\u514B",
      "state_nr": "\u7EBD\u82AC\u5170\u548C\u62C9\u5E03\u62C9\u591A",
      "state_ns": "\u897F\u5317\u5730\u533A",
      "state_na": "\u65B0\u65AF\u79D1\u820D",
      "state_nt": "\u52AA\u7EB3\u6B66\u7279",
      "state_oo": "\u5B89\u5927\u7565",
      "state_pe": "\u7231\u5FB7\u534E\u738B\u5B50\u5C9B",
      "state_qc": "\u9B41\u5317\u514B",
      "state_sn": "\u8428\u514B\u5176\u4E07",
      "state_yn": "\u80B2\u7A7A"
    },
    "inr": {
      "state_an": "\u5B89\u8FBE\u66FC\u548C\u5C3C\u79D1\u5DF4",
      "state_ap": "\u5B89\u5F97\u62C9\u90A6",
      "state_ar": "\u963F\u9C81\u7EB3\u6070\u5C14\u90A6",
      "state_as": "\u963F\u8428\u59C6\u90A6",
      "state_br": "\u6BD4\u54C8\u5C14\u90A6",
      "state_ch": "\u660C\u8FEA\u52A0\u5C14",
      "state_cg": "\u6070\u8482\u65AF\u52A0\u5C14\u90A6",
      "state_dnh": "\u8FBE\u5FB7\u62C9\u7EB3\u52A0\u5C14\u54C8\u7EF4\u5229",
      "state_dd": "\u8FBE\u66FC\u548C\u7B2C\u4E4C",
      "state_dl": "\u5FB7\u91CC",
      "state_ga": "\u679C\u963F",
      "state_gj": "\u53E4\u5409\u62C9\u7279\u90A6",
      "state_hr": "\u54C8\u91CC\u4E9A\u7EB3\u90A6",
      "state_hp": "\u559C\u9A6C\u5055\u5C14\u90A6",
      "state_jk": "\u67E5\u8C1F\u548C\u514B\u4EC0\u7C73\u5C14",
      "state_jh": "\u8D3E\u574E\u5FB7\u90A6",
      "state_ka": "\u5361\u7EB3\u5854\u514B\u90A6",
      "state_kl": "\u5580\u62C9\u62C9\u90A6",
      "state_la": "\u62C9\u8FBE\u514B",
      "state_ld": "\u62C9\u514B\u6C99\u5A01",
      "state_mp": "\u4E2D\u592E\u90A6",
      "state_mh": "\u9A6C\u54C8\u62C9\u65BD\u7279\u62C9\u90A6",
      "state_mn": "\u66FC\u5C3C\u666E\u5C14\u90A6",
      "state_ml": "\u6885\u52A0\u62C9\u4E9A\u90A6",
      "state_mz": "\u7C73\u4F50\u62C9\u59C6\u90A6",
      "state_nl": "\u90A3\u52A0\u5170\u90A6",
      "state_or": "\u5965\u91CC\u8428\u90A6",
      "state_ot": "\u5176\u4ED6\u5730\u533A",
      "state_ph": "\u672C\u5730\u6CBB\u91CC",
      "state_pb": "\u65C1\u906E\u666E\u90A6",
      "state_rj": "\u62C9\u8D3E\u65AF\u5766\u90A6",
      "state_sk": "\u9521\u91D1\u90A6",
      "state_tn": "\u6CF0\u7C73\u5C14\u7EB3\u5FB7\u90A6",
      "state_tg": "\u6CF0\u4F26\u52A0\u7EB3",
      "state_tr": "\u7279\u91CC\u666E\u62C9\u90A6",
      "state_up": "\u5317\u65B9\u90A6",
      "state_uk": "\u5317\u963F\u574E\u5FB7\u90A6",
      "state_wb": "\u897F\u5B5F\u52A0\u62C9\u90A6"
    },
    "country": {
      "AF": "阿富汗",
      "AX": "阿兰群岛",
      "AL": "阿尔巴尼亚",
      "DZ": "阿尔及利亚",
      "AS": "美属萨摩亚",
      "AD": "安道尔",
      "AO": "安哥拉",
      "AI": "安圭拉",
      "AQ": "南极洲",
      "AG": "安提瓜和巴布达",
      "AR": "阿根廷",
      "AM": "亚美尼亚",
      "AW": "阿鲁巴",
      "AC": "阿森松岛",
      "AU": "澳大利亚",
      "AT": "奥地利",
      "AZ": "阿塞拜疆",
      "BS": "巴哈马群岛",
      "BH": "巴林",
      "BD": "孟加拉国",
      "BB": "巴巴多斯",
      "BY": "白俄罗斯",
      "BE": "比利时",
      "BZ": "伯利兹城",
      "BJ": "贝宁",
      "BM": "百慕大群岛",
      "BT": "不丹",
      "BO": "多民族玻利维亚国",
      "BA": "波斯尼亚和黑塞哥维那",
      "BW": "博茨瓦纳",
      "BV": "布维岛",
      "BR": "巴西",
      "BQ": "博内尔岛、圣奥依斯坦图斯和萨巴岛",
      "IO": "英属印度洋领地",
      "VG": "维尔京群岛（英属）",
      "BN": "文莱达鲁萨兰国",
      "BG": "保加利亚",
      "BF": "布基纳法索",
      "BI": "布隆迪",
      "KH": "柬埔寨",
      "CM": "喀麦隆",
      "CA": "加拿大",
      "IC": "加那利群岛",
      "CT": "坎顿和恩德伯里群岛",
      "CV": "佛得角",
      "KY": "开曼群岛",
      "CF": "中非共和国",
      "EA": "休达和梅利亚",
      "TD": "乍得",
      "CL": "智利",
      "CN": "中国",
      "CX": "圣诞岛",
      "CP": "克利伯顿岛",
      "CC": "科科斯（基林）群岛",
      "CO": "哥伦比亚",
      "KM": "科摩罗",
      "CD": "刚果民主共和国",
      "CK": "库克群岛",
      "CR": "哥斯达黎加",
      "CI": "象牙海岸",
      "HR": "克罗地亚",
      "CU": "古巴",
      "CW": "库拉索岛",
      "CY": "塞浦路斯",
      "CZ": "捷克",
      "DK": "丹麦",
      "DG": "迭戈加西亚岛",
      "DJ": "吉布提",
      "DM": "多米尼克",
      "DO": "多米尼加共和国",
      "NQ": "毛德皇后地",
      "EC": "厄瓜多尔",
      "EG": "埃及",
      "SV": "萨尔瓦多",
      "GQ": "赤道几内亚",
      "ER": "厄立特尼亚",
      "EE": "爱沙尼亚",
      "ET": "埃塞俄比亚",
      "EU": "欧盟",
      "FK": "福克兰群岛（马尔维纳斯群岛）",
      "FO": "法罗群岛",
      "FJ": "斐济",
      "FI": "芬兰",
      "FR": "法国",
      "GF": "法属圭亚那",
      "PF": "法属波利尼西亚",
      "TF": "法属南半球领地",
      "FQ": "法属南方和南极领地",
      "GA": "加蓬",
      "GM": "冈比亚",
      "GE": "格鲁吉亚",
      "DE": "德国",
      "GH": "加纳",
      "GI": "直布罗陀",
      "GR": "希腊",
      "GL": "格林兰岛",
      "GD": "格林纳达",
      "GP": "瓜德罗普岛",
      "GU": "关岛",
      "GT": "危地马拉",
      "GG": "根西岛",
      "GN": "几内亚",
      "GW": "几内亚比绍",
      "GY": "圭亚那",
      "HT": "海地",
      "HM": "赫德岛和麦克唐纳群岛",
      "HN": "洪都拉斯",
      "HK": "香港特别行政区",
      "HU": "匈牙利",
      "IS": "冰岛",
      "IN": "印度",
      "ID": "印度尼西亚",
      "IR": "伊朗伊斯兰共和国",
      "IE": "爱尔兰",
      "IM": "英国属地曼岛",
      "IL": "以色列",
      "IQ": "伊拉克",
      "IT": "意大利",
      "JM": "牙买加",
      "JP": "日本",
      "JE": "泽西岛",
      "JT": "约翰斯顿岛",
      "JO": "约旦",
      "KZ": "哈萨克斯坦",
      "KE": "肯尼亚",
      "KI": "基里巴斯",
      "KP": "朝鲜民主主义人民共和国",
      "KR": "韩国",
      "XK": "科索沃",
      "KW": "科威特",
      "KG": "吉尔吉斯斯坦",
      "LA": "老挝人民民主共和国",
      "LV": "拉脱维亚",
      "LB": "黎巴嫩",
      "LS": "莱索托",
      "LR": "利比里亚",
      "LY": "利比亚",
      "LI": "列支敦士登",
      "LT": "立陶宛",
      "LU": "卢森堡",
      "MO": "澳门特别行政区",
      "MK": "北马其顿",
      "MG": "马达加斯加",
      "MW": "马拉维",
      "MY": "马来西亚",
      "MV": "马尔代夫",
      "ML": "马里",
      "MT": "马耳他",
      "MH": "马绍尔群岛",
      "MQ": "马提尼克",
      "MR": "毛里塔尼亚",
      "MU": "毛里求斯",
      "YT": "马约特岛",
      "FX": "法国大都会",
      "MX": "墨西哥",
      "FM": "密克罗尼西亚联邦",
      "MI": "中途岛",
      "MD": "摩尔多瓦共和国",
      "MC": "摩纳哥",
      "MN": "蒙古",
      "ME": "黑山共和国",
      "MS": "蒙特塞拉特岛",
      "MA": "摩洛哥",
      "MZ": "莫桑比克",
      "MM": "缅甸",
      "NA": "纳米比亚",
      "NR": "瑙鲁",
      "NP": "尼泊尔",
      "NL": "荷兰",
      "AN": "荷属安的列斯",
      "NT": "中立区",
      "NC": "新喀里多尼亚",
      "NZ": "新西兰",
      "NI": "尼加拉瓜",
      "NE": "尼日尔",
      "NG": "尼日利亚",
      "NU": "纽埃",
      "NF": "诺福克岛",
      "VD": "越南民主共和国",
      "MP": "北马里亚纳群岛",
      "NO": "挪威",
      "OM": "阿曼",
      "QO": "边远大洋洲",
      "PC": "太平洋岛屿托管地",
      "PK": "巴基斯坦",
      "PW": "帕劳",
      "PS": "巴勒斯坦",
      "PA": "巴拿马",
      "PZ": "巴拿马运河区",
      "PY": "巴拉圭",
      "YD": "也门人民民主共和国",
      "PE": "秘鲁",
      "PH": "菲律宾",
      "PN": "皮特凯恩群岛",
      "PL": "波兰",
      "PT": "葡萄牙",
      "PR": "波多黎各",
      "QA": "卡塔尔",
      "RE": "留尼旺岛",
      "RO": "罗马尼亚",
      "RU": "俄罗斯联邦",
      "RW": "卢旺达",
      "BL": "圣巴托洛缪岛",
      "SH": "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
      "KN": "圣基茨和尼维斯",
      "LC": "圣卢西亚岛",
      "MF": "圣马丁（法属）",
      "PM": "圣皮埃尔及密克隆岛",
      "VC": "圣文森特和格林纳丁斯",
      "WS": "萨摩亚",
      "SM": "圣马力诺",
      "ST": "圣多美和普林西比",
      "SA": "沙特阿拉伯",
      "SN": "塞内加尔",
      "RS": "塞尔维亚",
      "CS": "塞尔维亚和黑山",
      "SC": "塞舌尔",
      "SL": "塞拉利昂",
      "SG": "新加坡",
      "SX": "圣马丁（荷属）",
      "SK": "斯洛伐克",
      "SI": "斯洛文尼亚",
      "SB": "所罗门群岛",
      "SO": "索马里",
      "ZA": "南非",
      "GS": "南乔治亚岛和南桑威奇群岛",
      "ES": "西班牙",
      "LK": "斯里兰卡",
      "SR": "苏里南",
      "SJ": "斯瓦尔巴和扬马延",
      "SZ": "史瓦帝尼",
      "SE": "瑞典",
      "CH": "瑞士",
      "SY": "阿拉伯叙利亚共和国",
      "TW": "中国台湾",
      "TJ": "塔吉克斯坦",
      "TZ": "坦桑尼亚联合共和国",
      "TH": "泰国",
      "TL": "东帝汶",
      "TG": "多哥",
      "TK": "托克劳",
      "TO": "汤加",
      "TT": "特立尼达和多巴哥",
      "TA": "特里斯坦达库尼亚群岛",
      "TN": "突尼斯",
      "TR": "土耳其",
      "TM": "土库曼斯坦",
      "TC": "特克斯和凯科斯群岛",
      "TV": "图瓦卢",
      "UM": "美国本土外小岛屿",
      "PU": "美属太平洋群岛",
      "VI": "维尔京群岛（美属）",
      "UG": "乌干达",
      "UA": "乌克兰",
      "AE": "阿拉伯联合酋长国",
      "GB": "英国",
      "US": "美国",
      "UY": "乌拉圭",
      "UZ": "乌兹别克斯坦",
      "VU": "瓦努阿图",
      "VA": "梵蒂冈",
      "VE": "委内瑞拉玻利瓦尔共和国",
      "VN": "越南",
      "WK": "复活岛",
      "WF": "瓦利群岛和富图纳群岛",
      "EH": "西撒哈拉",
      "YE": "也门",
      "ZM": "赞比亚",
      "SD": "苏丹",
      "SS": "南苏丹",
      "ZW": "津巴布韦",
      "CG": "刚果",
      "PG": "巴布亚新几内亚",
      "XG": "全球移动卫星系统",
      "XC": "ITPCS试用",
      "XT": "国际免费电话",
      "XV": "国际网络",
      "XR": "国际付费服务",
      "XS": "成本共担服务",
      "XD": "减灾通信",
      "XP": "通用个人通信"
    }
  }
}
export default i18n
